export type ApiError = {
	error: string;
};

export type ApiResponse<T> = ApiError | T;

export const isApiError = <T>(response: ApiResponse<T>): response is ApiError =>
	(response as ApiError).error !== undefined;

export type SerializableParameter = string | string[] | boolean | undefined;
